<template>
    <div class="table-container">
        <!-- 固定顶部区域 -->
        <div class="fixed-header">
            <div>
                <el-button type="primary" :disabled="loading" @click="openDialog(null)">新建</el-button>
                <el-button type="danger" :disabled="loading" @click="importGames()">导入</el-button>
                <el-button
                  type="success"
                  :disabled="loading || selectedGameIds.size === 0"
                  @click="openBatchPropertyEditDialog"
                >
                  批量编辑 ({{ selectedGameIds.size }})
                </el-button>
                <el-button
                  type="warning"
                  :disabled="loading || selectedGameIds.size === 0"
                  @click="openBatchEditDialog"
                >
                  批量替换 URL ({{ selectedGameIds.size }})
                </el-button>
                <el-button type="danger" :disabled="loading || selectedGameIds.size === 0" @click="batchDelete()">批量删除 ({{ selectedGameIds.size }})</el-button>
            </div>
            <div style="display: flex;flex-wrap: wrap; margin-top: 10px">
              <el-select v-model="query.category" clearable filterable placeholder="分类" @change="reload" style="width: 140px">
                <el-option v-for="c in category_list" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
              <el-select v-model="query.webPlatform" clearable placeholder="平台" @change="reload" style="width: 140px">
                <el-option label="Puzzlegame" value="Puzzlegame"></el-option>
                <el-option label="Rabigame" value="Rabigame"></el-option>
              </el-select>
              <el-select v-model="query.isHot" placeholder="是否热门" clearable @change="reload" style="width: 120px">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
              <el-select v-model="query.isTopPerformer" placeholder="是否最受欢迎" clearable @change="reload" style="width: 140px">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
              <el-select v-model="query.isRecommended" placeholder="是否推荐" clearable @change="reload" style="width: 120px">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
              <el-select v-model="query.isNewGame" placeholder="是否新游戏" clearable @change="reload" style="width: 120px">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
              <el-select v-model="query.status" placeholder="状态" clearable @change="reload" style="width: 100px">
                <el-option label="上线" value="online"></el-option>
                <el-option label="下线" value="offline"></el-option>
                <el-option label="未上线" value=""></el-option>
              </el-select>
              <el-select v-model="query.source" placeholder="来源" clearable @change="reload" style="width: 140px">
                <el-option label="AGENT" value="AGENT"></el-option>
                <el-option label="gamedistribution" value="gamedistribution"></el-option>
                <el-option label="无来源" value=""></el-option>
              </el-select>
              <el-input v-model="query.title" placeholder="标题搜索" @blur="reload" @keyup.enter="reload" style="width: 160px"></el-input>
              <el-input v-model="query.name" placeholder="名字搜索" @blur="reload" @keyup.enter="reload" style="width: 160px"></el-input>
              <el-input v-model="query.gameId" placeholder="Game ID" @blur="reload" @keyup.enter="reload" style="width: 160px"></el-input>
            </div>
        </div>
        
        <!-- 表格区域 -->
        <div class="table-wrapper">
            <el-table v-loading="loading" :data="data" height="calc(100vh - 200px)" 
                      @selection-change="handleSelectionChange"
                      :row-key="getRowKey"
                      @select="handleSelect"
                      @select-all="handleSelectAll"
                      ref="gameTable">
        <el-table-column type="selection" width="55" :selectable="() => !loading" :reserve-selection="true"></el-table-column>
        <el-table-column label="排序" width="60" align="center" class-name="drag-handle-column">
          <template #default>
            <el-icon class="drag-handle" style="cursor: move; color: #909399; font-size: 18px;">
              <Rank />
            </el-icon>
          </template>
        </el-table-column>
        <el-table-column label="Game ID" width="150" prop="gameId"></el-table-column>
        <el-table-column label="预览游戏" width="100" align="center">
          <template #default="scope">
            <el-button
              type="primary"
              text
              :disabled="!getGamePreviewUrl(scope.row)"
              @click="openGamePreview(scope.row)"
            >
              预览
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="平台" width="120" prop="webPlatform">
          <template #default="scope">
            {{ scope.row.webPlatform || 'Rabigame' }}
          </template>
        </el-table-column>
        <el-table-column label="标题" width="150" prop="title">
          <template #default="scope">
            {{ scope.row.title || scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="开发者" width="140" prop="developerName"></el-table-column>
        <el-table-column label="评分" width="90" prop="rating"></el-table-column>
        <el-table-column label="投票" width="90" prop="voteCount"></el-table-column>
        <el-table-column label="点赞" width="90" prop="upvoteCount"></el-table-column>
        <el-table-column label="点踩" width="90" prop="downvoteCount"></el-table-column>
        <el-table-column label="关联文章" width="120">
          <template #default="scope">
            <el-tag v-if="scope.row.articleId" type="success">已关联</el-tag>
            <el-tag v-else type="info">未关联</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="200">
          <template #default="scope">
            <div v-if="(scope.row as any).editingCategory" class="category-edit-container">
              <el-select
                v-model="scope.row.category"
                size="small"
                filterable
                clearable
                placeholder="选择分类"
                style="width: 100%"
                :disabled="loading"
                @change="saveEditCategory(scope.row)"
                @visible-change="(visible) => handleCategorySelectVisibleChange(visible, scope.row)"
              >
                <el-option v-for="c in category_list" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
            </div>
            <div
              v-else
              class="category-display-wrapper"
              style="cursor: pointer;"
              @click="startEditCategory(scope.row)"
            >
              <el-tag v-if="displayCategoryLabel(scope.row)" type="info" style="margin: 3px">
                {{ displayCategoryLabel(scope.row) }}
              </el-tag>
              <span v-else style="color: #909399;">未分类</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图标" width="80px">
          <template #default="scope">
            <el-image v-if="scope.row.iconUrl || scope.row.icon" lazy 
                      :src="processImageUrl(scope.row.iconUrl || scope.row.icon, $CDN_URL)"
                      style="width: 30px; height: 30px; object-fit: cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="封面图" width="150px">
          <template #default="scope">
            <el-button v-if="scope.row.coverUrl || scope.row.cover" type="text" 
                       @click="showCoverDialog(processImageUrl(scope.row.coverUrl || scope.row.cover, $CDN_URL))">
              查看封面
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="是否热门" width="100">
          <template #default="scope">
            <el-switch
              :model-value="scope.row.isHot || false"
              :active-value="true"
              :inactive-value="false"
              @change="(val) => handleSwitchChange(scope.row, 'isHot', val)"
              :disabled="loading"
            />
          </template>
        </el-table-column>
        <el-table-column label="是否最受欢迎" width="120">
          <template #default="scope">
            <el-switch
              :model-value="scope.row.isTopPerformer || false"
              :active-value="true"
              :inactive-value="false"
              @change="(val) => handleSwitchChange(scope.row, 'isTopPerformer', val)"
              :disabled="loading"
            />
          </template>
        </el-table-column>
        <el-table-column label="是否推荐" width="100">
          <template #default="scope">
            <el-switch
              :model-value="scope.row.isRecommended || false"
              :active-value="true"
              :inactive-value="false"
              @change="(val) => handleSwitchChange(scope.row, 'isRecommended', val)"
              :disabled="loading"
            />
          </template>
        </el-table-column>
        <el-table-column label="是否新游戏" width="110">
          <template #default="scope">
            <el-switch
              :model-value="scope.row.isNewGame || false"
              :active-value="true"
              :inactive-value="false"
              @change="(val) => handleSwitchChange(scope.row, 'isNewGame', val)"
              :disabled="loading"
            />
          </template>
        </el-table-column>
        <el-table-column label="跳转到游戏URL" width="130">
          <template #default="scope">
            <el-switch
              :model-value="scope.row.goGameUrl || false"
              :active-value="true"
              :inactive-value="false"
              @change="(val) => handleSwitchChange(scope.row, 'goGameUrl', val)"
              :disabled="loading"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template #default="scope">
            <div v-if="scope.row.editingStatus === 'status'" class="status-edit-container">
              <el-select
                v-model="scope.row.status"
                size="small"
                clearable
                placeholder="选择状态"
                @change="saveEditStatus(scope.row)"
                @blur="cancelEditStatus(scope.row)"
                @visible-change="(visible) => handleStatusSelectVisibleChange(visible, scope.row)"
                ref="statusSelect"
              >
                <el-option label="上线" value="online"></el-option>
                <el-option label="下线" value="offline"></el-option>
                <el-option label="未上线" value=""></el-option>
              </el-select>
            </div>
            <div v-else @click="startEditStatus(scope.row, 'status')" class="status-display-wrapper" style="cursor: pointer;">
              <!-- 字段存在且为 online 显示上线 -->
              <el-tag v-if="scope.row.status === 'online'" type="success" style="margin: 3px">上线</el-tag>
              <!-- 字段存在且为 offline 显示下线 -->
              <el-tag v-else-if="scope.row.status === 'offline'" type="danger" style="margin: 3px">下线</el-tag>
              <!-- 字段为空、不存在或为其他值显示未上线 -->
              <el-tag v-else type="info" style="margin: 3px">未上线</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="150" prop="source">
          <template #default="scope">
            <el-tag v-if="scope.row.source" type="info">{{ scope.row.source }}</el-tag>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="150px" prop="publishedAt"></el-table-column>
        <el-table-column label="操作" width="380" fixed="right">
            <template #default="scope">
                <el-button type="warning" size="small" :loading="loading" @click="topGame(scope.row)" title="置顶">
                    置顶
                </el-button>
                <el-button type="success" circle icon="Top" :loading="loading"
                           :disabled="scope.$index===0" @click="moveUp(scope.$index)"></el-button>
                <el-button type="success" circle icon="Bottom" :loading="loading"
                           :disabled="scope.$index===data.length - 1" @click="moveDown(scope.$index)"></el-button>
                <el-button size="small" type="primary" :disabled="loading" @click="openArticleDialog(scope.row)">文章</el-button>
                <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="small" type="danger" :disabled="loading" @click="remove(scope.row)">删除</el-button>
            </template>
        </el-table-column>
            </el-table>
        </div>
        
        <!-- 固定分页区域 -->
        <div class="fixed-pagination">
            <div style="display: flex; justify-content: space-between">
              <el-pagination layout="prev, pager, next" :total="total" :page-size="query.limit || 20"
                             :current-page="page"
                             @current-change="pageChange" :disabled="loading"></el-pagination>
              <el-select v-model="query.limit" style="width: 100px" @change="reload" :disabled="loading">
                <el-option :value="20"></el-option>
                <el-option :value="50"></el-option>
                <el-option :value="100"></el-option>
              </el-select>
            </div>
        </div>
    <el-dialog v-model="dialog_opened" :before-close="reset">
        <game-form
            ref="gameForm"
            v-model:form="form"
            :loading="loading"
            :category-list="category_list"
            :label-list="label_list"
            :tag-list="tag_list"
        />
        <template #footer>
            <el-button type="primary" :loading="loading" @click="reset" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>

    <el-dialog v-model="articleDialogVisible" title="编辑文章" width="70%" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="游戏ID">
          <el-input v-model="articleForm.gameId" disabled />
        </el-form-item>
        <el-form-item label="文章标题">
          <el-input v-model="articleForm.title" placeholder="请输入文章标题" />
        </el-form-item>
        <el-tabs v-model="articleTab">
          <el-tab-pane label="编辑" name="edit">
            <el-input v-model="articleForm.content" type="textarea" :rows="16" placeholder="请输入 Markdown 内容" />
          </el-tab-pane>
          <el-tab-pane label="预览" name="preview">
            <div class="markdown-preview" v-html="renderMarkdown(articleForm.content)"></div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <template #footer>
        <el-button @click="articleDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="articleLoading" @click="saveArticle">保存文章</el-button>
      </template>
    </el-dialog>
    
    <!-- 封面图查看对话框 -->
    <el-dialog v-model="coverDialogVisible" title="封面图原图" width="80%">
        <el-image :src="coverImageUrl" fit="contain" style="width: 100%; height: 70vh;"></el-image>
    </el-dialog>

    <el-dialog
      v-model="gamePreviewDialogVisible"
      :title="`预览游戏：${gamePreviewRow?.title || gamePreviewRow?.name || '-'}`"
      width="75%"
      top="2vh"
      style="height: 96vh; margin-bottom: 0"
      :close-on-click-modal="false"
      destroy-on-close
      @closed="closeGamePreview"
    >
      <div class="game-preview-content">
        <div class="game-preview-toolbar">
          <div class="game-preview-controls">
            <span class="game-preview-label">上线状态</span>
            <el-select
              :model-value="gamePreviewRow?.status || ''"
              :disabled="gamePreviewUpdating"
              style="width: 110px"
              @change="updatePreviewStatus"
            >
              <el-option label="上线" value="online" />
              <el-option label="下线" value="offline" />
              <el-option label="未上线" value="" />
            </el-select>
            <span class="game-preview-label">分类</span>
            <el-select
              :model-value="gamePreviewRow?.category || ''"
              :disabled="gamePreviewUpdating"
              filterable
              clearable
              placeholder="未分类"
              style="width: 180px"
              @change="updatePreviewCategory"
            >
              <el-option v-for="c in category_list" :key="c.id" :label="c.name" :value="c.id" />
            </el-select>
          </div>
          <div class="game-preview-controls">
            <el-radio-group v-model="gamePreviewMode">
              <el-radio-button label="pc">PC 模式</el-radio-button>
              <el-radio-button label="mobile">移动端模式</el-radio-button>
            </el-radio-group>
            <span class="game-preview-size">
              {{ gamePreviewMode === 'pc' ? '桌面宽屏' : '390 × 700' }}
            </span>
            <el-button
              :disabled="gamePreviewUpdating || !hasAdjacentPreviewGame(-1)"
              @click="switchPreviewGame(-1)"
            >
              上一个
            </el-button>
            <el-button
              type="primary"
              :disabled="gamePreviewUpdating || !hasAdjacentPreviewGame(1)"
              @click="switchPreviewGame(1)"
            >
              下一个
            </el-button>
          </div>
        </div>
        <div class="game-preview-url">
          <span class="game-preview-label">游戏地址</span>
          <el-input
            :model-value="gamePreviewRow ? getGamePreviewUrl(gamePreviewRow) : ''"
            readonly
          />
        </div>
        <div class="game-preview-stage" :class="`is-${gamePreviewMode}`">
          <iframe
            v-if="gamePreviewRow && getGamePreviewUrl(gamePreviewRow)"
            :key="`${gamePreviewRow.id}-${gamePreviewMode}`"
            :src="getGamePreviewUrl(gamePreviewRow)"
            :title="gamePreviewRow.title || gamePreviewRow.name || '游戏预览'"
            allow="autoplay; fullscreen; gamepad"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-model="batchPropertyEditDialogVisible"
      title="批量编辑游戏"
      width="520px"
      :close-on-click-modal="false"
      @closed="resetBatchPropertyEditDialog"
    >
      <el-alert
        :title="`已选择 ${selectedGameIds.size} 个游戏`"
        type="info"
        :closable="false"
        style="margin-bottom: 20px"
      />
      <el-form label-width="110px">
        <el-form-item>
          <el-checkbox v-model="batchPropertyEditForm.updateStatus">修改上线状态</el-checkbox>
        </el-form-item>
        <el-form-item label="上线状态">
          <el-select
            v-model="batchPropertyEditForm.status"
            :disabled="!batchPropertyEditForm.updateStatus || batchPropertyEditLoading"
            style="width: 100%"
          >
            <el-option label="上线" value="online" />
            <el-option label="下线" value="offline" />
            <el-option label="未上线" value="" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="batchPropertyEditForm.updateCategory">修改分类</el-checkbox>
        </el-form-item>
        <el-form-item label="分类">
          <el-select
            v-model="batchPropertyEditForm.category"
            :disabled="!batchPropertyEditForm.updateCategory || batchPropertyEditLoading"
            filterable
            clearable
            placeholder="留空将清除分类"
            style="width: 100%"
          >
            <el-option v-for="c in category_list" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="batchPropertyEditForm.updateWebPlatform">修改平台</el-checkbox>
        </el-form-item>
        <el-form-item label="平台">
          <el-select
            v-model="batchPropertyEditForm.webPlatform"
            :disabled="!batchPropertyEditForm.updateWebPlatform || batchPropertyEditLoading"
            style="width: 100%"
          >
            <el-option label="Puzzlegame" value="Puzzlegame" />
            <el-option label="Rabigame" value="Rabigame" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button :disabled="batchPropertyEditLoading" @click="batchPropertyEditDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchPropertyEditLoading" @click="submitBatchPropertyEdit">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-model="batchEditDialogVisible"
      title="临时批量编辑游戏 URL"
      width="520px"
      :close-on-click-modal="false"
      @closed="resetBatchEditDialog"
    >
      <el-alert
        :title="`已选择 ${selectedGameIds.size} 个游戏，仅替换 gameUrl 中完全匹配的域名`"
        type="warning"
        :closable="false"
        style="margin-bottom: 20px"
      />
      <el-form label-width="100px">
        <el-form-item label="原域名" required>
          <el-input
            v-model.trim="batchEditForm.oldDomain"
            placeholder="例如：old.example.com"
            :disabled="batchEditLoading"
          />
        </el-form-item>
        <el-form-item label="新域名" required>
          <el-input
            v-model.trim="batchEditForm.newDomain"
            placeholder="例如：new.example.com"
            :disabled="batchEditLoading"
          />
        </el-form-item>
      </el-form>
      <div class="batch-edit-tip">
        只修改域名，URL 的协议、路径、查询参数和锚点保持不变；不匹配或格式无效的 URL 会被跳过。
      </div>
      <template #footer>
        <el-button :disabled="batchEditLoading" @click="batchEditDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchEditLoading" @click="submitBatchEdit">确认替换</el-button>
      </template>
    </el-dialog>
    
    <!-- 批量上传对话框 -->
    <el-dialog v-model="bulkDialogVisible" title="批量上传游戏" width="80%" :before-close="resetBulkDialog">
      <div style="margin-bottom: 20px">
        <el-upload
          :auto-upload="false"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :file-list="bulkFileList"
          :multiple="true"
          accept=".json,.zip"
          drag
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持 JSON 文件、ZIP 压缩包（可包含多级目录），支持多文件上传
            </div>
          </template>
        </el-upload>
      </div>
      
      <el-input
        v-model="bulkJsonText"
        type="textarea"
        :rows="15"
        placeholder="或者直接粘贴 JSON 数据（支持数组格式或 {games: [...]} 格式）"
      />
      
      <template #footer>
        <el-button @click="resetBulkDialog">取消</el-button>
        <el-button type="primary" :loading="bulkLoading" @click="submitBulkUpload">上传</el-button>
      </template>
    </el-dialog>
    
    <!-- 批量上传结果对话框 -->
    <el-dialog v-model="bulkResultDialogVisible" title="批量上传结果" width="70%">
      <div>
        <el-alert
          :title="`总计: ${bulkResult.total} | 成功: ${bulkResult.successCount} | 失败: ${bulkResult.failedCount}`"
          :type="bulkResult.failedCount > 0 ? 'warning' : 'success'"
          :closable="false"
          style="margin-bottom: 20px"
        />
        
        <el-tabs v-model="activeResultTab">
          <el-tab-pane label="成功列表" name="success">
            <el-table :data="bulkResult.success" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
              <el-table-column label="ID" prop="id"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失败列表" name="failed">
            <el-table :data="bulkResult.failed" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
              <el-table-column label="错误信息" prop="error" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <el-button type="primary" @click="bulkResultDialogVisible = false; init()">确定</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传相关游戏对话框 -->
    <el-dialog v-model="relateBulkDialogVisible" title="上传相关游戏" width="80%" :before-close="resetRelateBulkDialog">
      <div style="margin-bottom: 20px">
        <el-upload
          :auto-upload="false"
          :on-change="handleRelateFileChange"
          :show-file-list="false"
          accept=".json"
          drag
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将 JSON 文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持 JSON 格式文件，格式参考 gameRelateMap.json
            </div>
          </template>
        </el-upload>
      </div>
      
      <el-input
        v-model="relateBulkJsonText"
        type="textarea"
        :rows="15"
        placeholder='或者直接粘贴 JSON 数据（格式: {gameId: [{"id": "...", "score": 0.123, "gameMd5": "..."}, ...]}）'
      />
      
      <template #footer>
        <el-button @click="resetRelateBulkDialog">取消</el-button>
        <el-button type="primary" :loading="relateBulkLoading" @click="submitRelateBulkUpload">上传</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传相关游戏结果对话框 -->
    <el-dialog v-model="relateBulkResultDialogVisible" title="上传相关游戏结果" width="70%">
      <div>
        <el-alert
          :title="`总计: ${relateBulkResult.total} | 成功: ${relateBulkResult.successCount} | 失败: ${relateBulkResult.failedCount}`"
          :type="relateBulkResult.failedCount > 0 ? 'warning' : 'success'"
          :closable="false"
          style="margin-bottom: 20px"
        />
        
        <el-tabs v-model="activeRelateResultTab">
          <el-tab-pane label="成功列表" name="success">
            <el-table :data="relateBulkResult.success" max-height="400">
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="相关游戏数" prop="relatedCount"></el-table-column>
              <el-table-column label="ID" prop="id"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失败列表" name="failed">
            <el-table :data="relateBulkResult.failed" max-height="400">
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="错误信息" prop="error" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <el-button type="primary" @click="relateBulkResultDialogVisible = false">确定</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传热门游戏对话框 -->
    <el-dialog v-model="hotBulkDialogVisible" title="上传热门游戏" width="80%" :before-close="resetHotBulkDialog">
      <div style="margin-bottom: 20px">
        <el-upload
          :auto-upload="false"
          :on-change="handleHotFileChange"
          :show-file-list="false"
          accept=".json"
          drag
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将 JSON 文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持 JSON 格式文件，格式参考 hot-1.json
            </div>
          </template>
        </el-upload>
      </div>
      
      <el-input
        v-model="hotBulkJsonText"
        type="textarea"
        :rows="15"
        placeholder='或者直接粘贴 JSON 数据（格式: [{...}, {...}]）'
      />
      
      <template #footer>
        <el-button @click="resetHotBulkDialog">取消</el-button>
        <el-button type="primary" :loading="hotBulkLoading" @click="submitHotBulkUpload">上传</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传热门游戏结果对话框 -->
    <el-dialog v-model="hotBulkResultDialogVisible" title="上传热门游戏结果" width="70%">
      <div>
        <el-alert
          :title="`总计: ${hotBulkResult.total} | 成功: ${hotBulkResult.successCount} | 失败: ${hotBulkResult.failedCount}`"
          :type="hotBulkResult.failedCount > 0 ? 'warning' : 'success'"
          :closable="false"
          style="margin-bottom: 20px"
        />
        
        <el-tabs v-model="activeHotResultTab">
          <el-tab-pane label="成功列表" name="success">
            <el-table :data="hotBulkResult.success" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失败列表" name="failed">
            <el-table :data="hotBulkResult.failed" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
              <el-table-column label="错误信息" prop="error" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <el-button type="primary" @click="hotBulkResultDialogVisible = false; init()">确定</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传最受欢迎游戏对话框 -->
    <el-dialog v-model="topPerformerBulkDialogVisible" title="上传最受欢迎游戏" width="80%" :before-close="resetTopPerformerBulkDialog">
      <div style="margin-bottom: 20px">
        <el-upload
          :auto-upload="false"
          :on-change="handleTopPerformerFileChange"
          :show-file-list="false"
          accept=".json"
          drag
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将 JSON 文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持 JSON 格式文件，格式参考 TopPerformer-1.json
            </div>
          </template>
        </el-upload>
      </div>
      
      <el-input
        v-model="topPerformerBulkJsonText"
        type="textarea"
        :rows="15"
        placeholder='或者直接粘贴 JSON 数据（格式: [{...}, {...}]）'
      />
      
      <template #footer>
        <el-button @click="resetTopPerformerBulkDialog">取消</el-button>
        <el-button type="primary" :loading="topPerformerBulkLoading" @click="submitTopPerformerBulkUpload">上传</el-button>
      </template>
    </el-dialog>
    
    <!-- 上传最受欢迎游戏结果对话框 -->
    <el-dialog v-model="topPerformerBulkResultDialogVisible" title="上传最受欢迎游戏结果" width="70%">
      <div>
        <el-alert
          :title="`总计: ${topPerformerBulkResult.total} | 成功: ${topPerformerBulkResult.successCount} | 失败: ${topPerformerBulkResult.failedCount}`"
          :type="topPerformerBulkResult.failedCount > 0 ? 'warning' : 'success'"
          :closable="false"
          style="margin-bottom: 20px"
        />
        
        <el-tabs v-model="activeTopPerformerResultTab">
          <el-tab-pane label="成功列表" name="success">
            <el-table :data="topPerformerBulkResult.success" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失败列表" name="failed">
            <el-table :data="topPerformerBulkResult.failed" max-height="400">
              <el-table-column label="序号" prop="index" width="80"></el-table-column>
              <el-table-column label="Game ID" prop="gameId"></el-table-column>
              <el-table-column label="标题" prop="title"></el-table-column>
              <el-table-column label="错误信息" prop="error" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <el-button type="primary" @click="topPerformerBulkResultDialogVisible = false; init()">确定</el-button>
      </template>
    </el-dialog>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {update, deepcopy, processImageUrl} from "../../utils/utils";
import {ElMessageBox, ElMessage} from 'element-plus'
import {UploadFilled, Rank} from '@element-plus/icons-vue'
import {GameApi, Game, GameListResponse, CategoryOption} from '../../api/gameApi';
import {ArticleApi} from '../../api/articleApi';
import GameForm from '../../components/business/GameForm.vue';

// 动态导入 sortablejs
let Sortable: any = null;
const loadSortable = async () => {
  try {
    const sortableModule = await import('sortablejs');
    Sortable = sortableModule.default || sortableModule;
  } catch (e) {
    console.warn('sortablejs 未安装，拖拽排序功能将不可用。请运行: npm install sortablejs');
  }
};

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $CDN_URL: string;
  }
}

export default defineComponent({
    name: "Game",
    components: {
        GameForm,
        Rank
    },
    data() {
        return {
            loading: false, 
            data: [] as Game[], 
            editing: null as Game | null, 
            dialog_opened: false, 
            total: 0, 
            page: 1,
            category_list: [] as CategoryOption[],
            label_list: ["Hot"] as string[],
            tag_list: [] as string[], 
            suggested_tag_list: ["Casual"] as string[],
            selectedGames: [] as Game[],
            selectedGameIds: new Set<string>(), // 用于跨页多选
            batchPropertyEditDialogVisible: false,
            batchPropertyEditLoading: false,
            batchPropertyEditForm: {
              updateStatus: false,
              status: 'online',
              updateCategory: false,
              category: '',
              updateWebPlatform: false,
              webPlatform: 'Rabigame' as 'Puzzlegame' | 'Rabigame',
            },
            batchEditDialogVisible: false,
            batchEditLoading: false,
            batchEditForm: {
              oldDomain: '',
              newDomain: '',
            },
            query: {
              id: null as string | null,
              gameId: null as string | null,
              category: null as string | null,
              webPlatform: null as 'Puzzlegame' | 'Rabigame' | null,
              limit: 20,
              skip: 0,
              title: null as string | null,
              isHot: null as boolean | null,
              isTopPerformer: null as boolean | null,
              isRecommended: null as boolean | null,
              isNewGame: null as boolean | null,
              status: null as string | null,
              source: null as string | null,
              // 兼容旧字段
              hot: null as boolean | null,
              recommended: null as boolean | null,
              name: null as string | null,
            },
            form: this.createForm(),
            editingStatus: null as string | null, // Track which status is being edited
            originalStatusValue: '' as string, // Store original status value for cancel
            // 封面图对话框
            coverDialogVisible: false,
            coverImageUrl: '',
            // 游戏预览对话框
            gamePreviewDialogVisible: false,
            gamePreviewRow: null as Game | null,
            gamePreviewMode: 'pc' as 'pc' | 'mobile',
            gamePreviewUpdating: false,
            // 批量上传相关
            bulkDialogVisible: false,
            bulkJsonText: '',
            bulkFileList: [] as any[],
            bulkLoading: false,
            bulkResultDialogVisible: false,
            bulkResult: {
              total: 0,
              successCount: 0,
              failedCount: 0,
              success: [],
              failed: []
            },
            activeResultTab: 'success',
            // 上传相关游戏相关
            relateBulkDialogVisible: false,
            relateBulkJsonText: '',
            relateBulkLoading: false,
            relateBulkResultDialogVisible: false,
            relateBulkResult: {
              total: 0,
              successCount: 0,
              failedCount: 0,
              success: [],
              failed: []
            },
            activeRelateResultTab: 'success',
            // 热门游戏上传相关
            hotBulkDialogVisible: false,
            hotBulkJsonText: '',
            hotBulkLoading: false,
            hotBulkResultDialogVisible: false,
            hotBulkResult: {
              total: 0,
              successCount: 0,
              failedCount: 0,
              success: [],
              failed: []
            },
            activeHotResultTab: 'success',
            // 最受欢迎游戏上传相关
            topPerformerBulkDialogVisible: false,
            topPerformerBulkJsonText: '',
            topPerformerBulkLoading: false,
            topPerformerBulkResultDialogVisible: false,
            topPerformerBulkResult: {
              total: 0,
              successCount: 0,
              failedCount: 0,
              success: [],
              failed: []
            },
            activeTopPerformerResultTab: 'success',
            // 文章编辑
            articleDialogVisible: false,
            articleLoading: false,
            articleTab: 'edit',
            articleForm: {
              id: '',
              gameId: '',
              title: '',
              content: '',
            },
            // 拖拽排序相关
            sortableInstance: null as any
        }
    },
    methods: {
        processImageUrl,
        getCategoryName(categoryId: string): string {
            if (!categoryId) return '';
            const found = this.category_list.find((c) => c.id === categoryId);
            return found ? found.name : categoryId;
        },
        displayCategoryLabel(game: Game): string {
            const name = (game.categoryName || '').trim();
            if (name) return name;
            return this.getCategoryName(game.category || '');
        },
        normalizeCategoryId(v: string | undefined | null): string {
            if (v === undefined || v === null) return '';
            return String(v);
        },
        renderMarkdown(text: string): string {
            const escaped = (text || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            return escaped
                .replace(/^### (.*)$/gm, '<h3>$1</h3>')
                .replace(/^## (.*)$/gm, '<h2>$1</h2>')
                .replace(/^# (.*)$/gm, '<h1>$1</h1>')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*(.*?)\*/g, '<em>$1</em>')
                .replace(/`([^`]+)`/g, '<code>$1</code>')
                .replace(/\n/g, '<br/>');
        },
        async openArticleDialog(row: Game): Promise<void> {
          if (!row.gameId) {
            ElMessage.error('当前游戏缺少 gameId，无法关联文章');
            return;
          }
          this.articleDialogVisible = true;
          this.articleTab = 'edit';
          this.articleForm = { id: '', gameId: row.gameId, title: `${row.title || row.name || row.gameId}`, content: '' };
          try {
            const article = await ArticleApi.getByGameId(row.gameId);
            if (article) {
              this.articleForm = {
                id: article.id,
                gameId: article.gameId,
                title: article.title,
                content: article.content,
              };
            }
          } catch (error: any) {
            ElMessage.error('加载文章失败：' + (error.message || '未知错误'));
          }
        },
        async saveArticle(): Promise<void> {
          if (!this.articleForm.gameId || !this.articleForm.title) {
            ElMessage.error('请填写文章标题');
            return;
          }
          this.articleLoading = true;
          try {
            if (this.articleForm.id) {
              await ArticleApi.update(this.articleForm.id, {
                gameId: this.articleForm.gameId,
                title: this.articleForm.title,
                content: this.articleForm.content,
              });
            } else {
              const row = await ArticleApi.create({
                gameId: this.articleForm.gameId,
                title: this.articleForm.title,
                content: this.articleForm.content,
              });
              this.articleForm.id = row.id;
            }
            ElMessage.success('文章保存成功');
            this.articleDialogVisible = false;
            this.loading = false;
            await this.init();
          } catch (error: any) {
            ElMessage.error('文章保存失败：' + (error.message || '未知错误'));
          } finally {
            this.articleLoading = false;
          }
        },
        async init(): Promise<void> {
            // 如果正在加载，避免重复请求
            if (this.loading) {
                return;
            }
            
            this.loading = true;
            try {
                // 并行获取游戏列表和分类列表
                const [gamesRes, categoriesRes] = await Promise.all([
                    GameApi.getGames(this.query),
                    GameApi.getCategories()
                ]);
                
                // 确保布尔字段有默认值，避免 switch 组件触发意外事件
                const processedGames = gamesRes.gameList.map((g: any) => ({
                    ...g,
                    isHot: g.isHot ?? false,
                    isTopPerformer: g.isTopPerformer ?? false,
                    isRecommended: g.isRecommended ?? false,
                    isNewGame: g.isNewGame ?? false,
                    goGameUrl: g.goGameUrl ?? false,
                    developerName: g.developerName ?? '',
                    rating: g.rating ?? 0,
                    voteCount: g.voteCount ?? 0,
                    upvoteCount: g.upvoteCount ?? 0,
                    downvoteCount: g.downvoteCount ?? 0,
                    articleId: g.articleId ?? '',
                    categoryName: g.categoryName || this.getCategoryName(g.category),
                    webPlatform: g.webPlatform || 'Rabigame',
                    // status 字段：如果不存在或为空，保持为空（未上线）；如果存在且为 online/offline，保持原值
                    status: (g.status !== undefined && g.status !== null && g.status !== '') ? g.status : '',
                }));
                
                // 更新游戏数据
                this.data = processedGames;
                this.total = gamesRes.total;
                
                // 恢复当前页的选中状态
                this.$nextTick(() => {
                    this.restoreSelection();
                    // 初始化拖拽排序
                    this.initSortable();
                });
                
                // 更新分类列表
                this.category_list = categoriesRes;
                
                // 更新标签列表
                this.tag_list = [...this.suggested_tag_list];
                this.data.forEach(g => {
                    if (g.tags) {
                        g.tags.forEach(t => {
                            if (!this.tag_list.includes(t)) {
                                this.tag_list.push(t);
                            }
                        });
                    }
                });
            } catch (error) {
                console.error('初始化数据失败:', error);
            } finally {
                this.loading = false;
            }
        },
        importGames() {
          GameApi.importGames().then(() => {
            this.init();
          });
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                if (item) {
                    update(this.form, item);
                    this.form.webPlatform = item.webPlatform || 'Rabigame';
                    if(!this.form.is_recommended) {
                      this.form.is_recommended = false;
                    }
                    if(!this.form.is_hot) {
                      this.form.is_hot = false;
                    }
                    this.editing = item;
                }
            })
        },
        reset() {
            if (this.$refs.gameForm) {
              this.$refs.gameForm.resetFields();
            }
            this.dialog_opened = this.loading = false;
            this.editing = null;
            this.form = this.createForm();
        },
        submit() {
            this.$refs.gameForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        GameApi.updateGame(this.editing.id, this.form)
                            .then(async () => {
                                this.loading = false;
                                await this.init();
                                this.reset();
                            })
                            .catch((err) => {
                                console.error('更新游戏失败:', err);
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } else {
                        GameApi.createGame(this.form)
                            .then(async () => {
                                this.page = 1;
                                this.query.skip = 0;
                                this.loading = false;
                                await this.init();
                                this.reset();
                            })
                            .catch((err) => {
                                console.error('创建游戏失败:', err);
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                }
            });
        },
        async remove(row) {
            ElMessageBox.confirm(`确定要删除游戏 "${row.title || row.name || row.gameId || row.id}" 吗？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(async () => {
                this.loading = true;
                try {
                    await GameApi.deleteGame(row.id);
                    ElMessage.success('删除成功');
                    // 从选中集合中移除（如果存在）
                    this.selectedGameIds.delete(row.id);
                    // 先释放 loading，避免 init() 因 loading=true 被提前 return
                    this.loading = false;
                    await this.init();
                } catch (error: any) {
                    ElMessage.error('删除失败：' + (error.message || '未知错误'));
                } finally {
                    this.loading = false;
                }
            }).catch(() => {});
        },
        getRowKey(row: Game) {
            return row.id;
        },
        handleSelectionChange(selection: Game[]) {
            this.selectedGames = selection;
            // 更新选中ID集合（当前页的）
            const currentPageIds = new Set(this.data.map(g => g.id));
            // 移除当前页已取消选中的
            currentPageIds.forEach(id => {
                if (!selection.find(g => g.id === id)) {
                    this.selectedGameIds.delete(id);
                }
            });
            // 添加当前页新选中的
            selection.forEach(game => {
                this.selectedGameIds.add(game.id);
            });
        },
        handleSelect(selection: Game[], row: Game) {
            // 单个选择/取消选择
            if (selection.includes(row)) {
                this.selectedGameIds.add(row.id);
            } else {
                this.selectedGameIds.delete(row.id);
            }
        },
        handleSelectAll(selection: Game[]) {
            // 全选/取消全选当前页
            if (selection.length > 0) {
                // 全选：添加当前页所有游戏ID
                this.data.forEach(game => {
                    this.selectedGameIds.add(game.id);
                });
            } else {
                // 取消全选：移除当前页所有游戏ID
                this.data.forEach(game => {
                    this.selectedGameIds.delete(game.id);
                });
            }
        },
        openBatchPropertyEditDialog(): void {
            if (this.selectedGameIds.size === 0) {
                ElMessage.warning('请至少选择一个游戏');
                return;
            }
            this.batchPropertyEditDialogVisible = true;
        },
        resetBatchPropertyEditDialog(): void {
            if (this.batchPropertyEditLoading) return;
            this.batchPropertyEditForm.updateStatus = false;
            this.batchPropertyEditForm.status = 'online';
            this.batchPropertyEditForm.updateCategory = false;
            this.batchPropertyEditForm.category = '';
            this.batchPropertyEditForm.updateWebPlatform = false;
            this.batchPropertyEditForm.webPlatform = 'Rabigame';
        },
        async submitBatchPropertyEdit(): Promise<void> {
            const form = this.batchPropertyEditForm;
            if (!form.updateStatus && !form.updateCategory && !form.updateWebPlatform) {
                ElMessage.warning('请至少选择一个要修改的属性');
                return;
            }

            const updates: {
              status?: string;
              category?: string;
              webPlatform?: 'Puzzlegame' | 'Rabigame';
            } = {};
            if (form.updateStatus) updates.status = form.status;
            if (form.updateCategory) updates.category = form.category;
            if (form.updateWebPlatform) updates.webPlatform = form.webPlatform;

            this.batchPropertyEditLoading = true;
            try {
                const result = await GameApi.bulkUpdateGames(
                    Array.from(this.selectedGameIds),
                    updates
                );
                this.batchPropertyEditDialogVisible = false;
                if (result.successCount > 0) {
                    ElMessage.success(`成功更新 ${result.successCount} 个游戏`);
                }
                if (result.failedCount > 0) {
                    ElMessage.warning(`${result.failedCount} 个游戏更新失败`);
                }
                this.loading = false;
                await this.init();
            } catch (error: any) {
                ElMessage.error('批量编辑失败：' + (error.message || '未知错误'));
            } finally {
                this.batchPropertyEditLoading = false;
            }
        },
        openBatchEditDialog(): void {
            if (this.selectedGameIds.size === 0) {
                ElMessage.warning('请至少选择一个游戏');
                return;
            }
            this.batchEditDialogVisible = true;
        },
        resetBatchEditDialog(): void {
            if (this.batchEditLoading) return;
            this.batchEditForm.oldDomain = '';
            this.batchEditForm.newDomain = '';
        },
        normalizeDomainInput(value: string): string {
            const trimmed = value.trim();
            if (!trimmed) return '';
            try {
                const parsed = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`);
                if (parsed.pathname !== '/' || parsed.search || parsed.hash || parsed.username || parsed.password) {
                    return '';
                }
                return parsed.host;
            } catch {
                return '';
            }
        },
        async submitBatchEdit(): Promise<void> {
            const ids = Array.from(this.selectedGameIds);
            const oldDomain = this.normalizeDomainInput(this.batchEditForm.oldDomain);
            const newDomain = this.normalizeDomainInput(this.batchEditForm.newDomain);

            if (!oldDomain || !newDomain) {
                ElMessage.warning('请输入有效域名，可包含端口，但不能包含路径或参数');
                return;
            }
            if (oldDomain.toLowerCase() === newDomain.toLowerCase()) {
                ElMessage.warning('新域名不能与原域名相同');
                return;
            }

            this.batchEditLoading = true;
            try {
                const result = await GameApi.bulkReplaceGameUrlDomain(ids, oldDomain, newDomain);
                this.batchEditDialogVisible = false;
                if (result.updatedCount > 0) {
                    ElMessage.success(`已更新 ${result.updatedCount} 个游戏 URL`);
                }
                if (result.skippedCount > 0 || result.failedCount > 0) {
                    ElMessage.warning(`跳过 ${result.skippedCount} 个，失败 ${result.failedCount} 个`);
                }
                this.loading = false;
                await this.init();
            } catch (error: any) {
                ElMessage.error('批量编辑失败：' + (error.message || '未知错误'));
            } finally {
                this.batchEditLoading = false;
            }
        },
        async batchDelete() {
            const selectedIds = Array.from(this.selectedGameIds);
            if (selectedIds.length === 0) {
                ElMessage.warning('请至少选择一个游戏');
                return;
            }
            
            ElMessageBox.confirm(
                `确定要删除选中的 ${selectedIds.length} 个游戏吗？`,
                '批量删除确认',
                {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning',
                }
            ).then(async () => {
                this.loading = true;
                try {
                    const result = await GameApi.bulkDeleteGames(selectedIds);
                    
                    if (result.successCount > 0) {
                        ElMessage.success(`成功删除 ${result.successCount} 个游戏`);
                        // 从选中集合中移除成功删除的游戏
                        result.success.forEach((item: any) => {
                            this.selectedGameIds.delete(item.id);
                        });
                    }
                    
                    if (result.failedCount > 0) {
                        const failedNames = result.failed.map((f: any) => f.id).join('、');
                        ElMessage.warning(`${result.failedCount} 个游戏删除失败：${failedNames}`);
                    }
                    
                    // 先释放 loading，避免 init() 因 loading=true 被提前 return
                    this.loading = false;
                    await this.init();
                    
                    // 恢复当前页的选中状态
                    this.$nextTick(() => {
                        this.restoreSelection();
                    });
                } catch (error: any) {
                    ElMessage.error('批量删除操作失败：' + (error.message || '未知错误'));
                } finally {
                    this.loading = false;
                }
            }).catch(() => {});
        },
        restoreSelection() {
            // 恢复当前页的选中状态
            if (this.$refs.gameTable) {
                const table = this.$refs.gameTable as any;
                this.data.forEach((game: Game) => {
                    if (this.selectedGameIds.has(game.id)) {
                        table.toggleRowSelection(game, true);
                    }
                });
            }
        },
        update(row) {
            this.loading = true;
            GameApi.updateGame(row.id, row)
                .finally(() => {
                    this.loading = false;
                });
        },
        moveUp(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index - 1, 0, row[0]);
            this.resort();
        },
        moveDown(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index + 1, 0, row[0]);
            this.resort();
        },
        // 初始化拖拽排序
        async initSortable() {
            // 如果 Sortable 还未加载，先加载它
            if (!Sortable) {
                await loadSortable();
            }
            
            if (!Sortable) {
                console.warn('sortablejs 未安装，无法使用拖拽排序功能');
                return;
            }
            
            // 销毁旧的实例
            if (this.sortableInstance) {
                this.sortableInstance.destroy();
                this.sortableInstance = null;
            }
            
            // 等待表格渲染完成
            await this.$nextTick();
            
            const tbody = document.querySelector('.table-wrapper .el-table__body-wrapper tbody');
            if (!tbody) {
                return;
            }
            
            this.sortableInstance = Sortable.create(tbody, {
                handle: '.drag-handle',
                animation: 150,
                onEnd: (evt: any) => {
                    const { oldIndex, newIndex } = evt;
                    if (oldIndex === newIndex || oldIndex === undefined || newIndex === undefined) {
                        return;
                    }
                    
                    // 移动数组元素
                    const movedRow = this.data.splice(oldIndex, 1)[0];
                    this.data.splice(newIndex, 0, movedRow);
                    
                    // 保存排序
                    this.resort();
                }
            });
        },
        resort() {
            const sort = this.data.map(d => d.id);
            this.loading = true;
            GameApi.sortGames(sort)
                .then(() => {
                    ElMessage.success('排序保存成功');
                })
                .catch((error) => {
                    ElMessage.error('排序保存失败：' + (error.message || '未知错误'));
                    // 失败时重新加载数据
                    this.init();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async topGame(row: Game) {
            if (!row.id) {
                ElMessage.error('游戏ID不存在');
                return;
            }
            
            ElMessageBox.confirm(
                `确定要将游戏 "${row.title || row.name || row.gameId || row.id}" 置顶吗？`,
                '置顶确认',
                {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'info',
                }
            ).then(async () => {
                this.loading = true;
                try {
                    await GameApi.topGame(row.id);
                    ElMessage.success('置顶成功');
                    // 先释放 loading，避免 init() 因 loading=true 被提前 return
                    this.loading = false;
                    await this.init();
                } catch (error: any) {
                    ElMessage.error('置顶失败：' + (error.message || '未知错误'));
                } finally {
                    this.loading = false;
                }
            }).catch(() => {});
        },
        createForm(): Game {
          return {
            id: '',
            companyName: '',
            coverUrl: '',
            iconUrl: '',
            title: '',
            category: '',
            desc: '',
            gameId: '',
            gameMd5: '',
            gameUrl: '',
            webPlatform: 'Rabigame',
            tags: [],
            mobileMode: '',
            mobile: [],
            instruction: '',
            languages: [],
            developerName: '',
            rating: 0,
            voteCount: 0,
            upvoteCount: 0,
            downvoteCount: 0,
            articleId: '',
            // 兼容旧字段
            cover: '',
            icon: '',
            url: "",
            active: false,
            name: "",
            label: "",
            is_hot: false,
            is_recommended: false,
            status: '', // 默认状态为空（未上线）
          } as Game;
        },
        pageChange(page: number): void {
          this.page = page;
          this.query.skip = (page - 1) * this.query.limit;
          this.init();
        },
        reload(): void {
          // 如果正在加载，忽略操作
          if (this.loading) {
            return;
          }
          
          // 清除之前的防抖定时器
          if ((this as any).reloadTimer) {
            clearTimeout((this as any).reloadTimer);
          }
          
          // 使用防抖，避免频繁请求
          (this as any).reloadTimer = setTimeout(() => {
            if (!this.query.id || this.query.id.length === 24) {
              this.query.skip = 0;
              this.page = 1;
              this.init();
            }
          }, 300); // 300ms 防抖
        },
        // 处理开关变化（带防抖和去重）
        handleSwitchChange(game: Game, field: string, value: any): void {
          // 如果正在加载，忽略操作
          if (this.loading) {
            return;
          }
          
          // 如果值没有变化，不执行更新
          const currentValue = game[field as keyof Game];
          if (currentValue === value) {
            return;
          }
          
          // 立即更新UI，提供即时反馈
          (game as any)[field] = value;
          
          // 为每个游戏字段创建独立的防抖定时器，避免不同字段互相影响
          const timerKey = `${game.id}_${field}`;
          
          // 清除之前的定时器
          if ((this as any)[`switchTimer_${timerKey}`]) {
            clearTimeout((this as any)[`switchTimer_${timerKey}`]);
          }
          
          // 设置新的防抖定时器
          (this as any)[`switchTimer_${timerKey}`] = setTimeout(() => {
            this.updateGameField(game, field, value);
            delete (this as any)[`switchTimer_${timerKey}`];
          }, 800); // 800ms 防抖，避免频繁请求
        },
        
        // 更新游戏字段（原地编辑）
        async updateGameField(game: Game, field: string, value: any): Promise<void> {
          if (!game.id) {
            ElMessage.error('游戏ID不存在');
            return;
          }
          
          // 保存原始值，用于失败时恢复
          const originalValue = game[field as keyof Game];
          
          try {
            const updateData: any = {};
            updateData[field] = value;
            
            await GameApi.updateGame(game.id, updateData);
            // 不调用 init()，只更新当前行的数据，避免重新加载整个列表
            // 数据已经在 handleSwitchChange 中更新了
          } catch (error) {
            console.error('更新失败:', error);
            ElMessage.error('更新失败，请重试');
            // 恢复原值
            (game as any)[field] = originalValue;
          }
        },
        
        // 开始编辑状态
        startEditStatus(game: Game, field: string): void {
          if (this.loading) return;
          this.editingStatus = field;
          (game as any).editingStatus = field; // Add a flag to the row for UI
          // 保存原始值：如果 status 不存在或为空，保存为空字符串（未上线）
          const currentStatus = (game as any).status;
          (game as any).originalStatus = (currentStatus !== undefined && currentStatus !== null) ? currentStatus : '';
          this.originalStatusValue = (game as any).originalStatus;
          this.$nextTick(() => {
            const selectRef = this.$refs.statusSelect as any;
            if (selectRef && selectRef.focus) {
              selectRef.focus();
            }
          });
        },
        
        // 保存状态编辑
        async saveEditStatus(game: Game): Promise<void> {
          if (this.loading || !(game as any).editingStatus) return;
          
          // Only save if the value has actually changed
          if ((game as any).status === (game as any).originalStatus) {
            this.cancelEditStatus(game);
            return;
          }
          
          this.loading = true;
          try {
            await GameApi.updateGame(game.id, { status: (game as any).status || '' } as Partial<Game>);
            ElMessage.success('状态更新成功');
          } catch (error) {
            console.error('更新状态失败:', error);
            ElMessage.error('更新状态失败，已恢复原值');
            (game as any).status = (game as any).originalStatus; // Revert on failure
          } finally {
            this.loading = false;
            this.editingStatus = null;
            (game as any).editingStatus = null;
          }
        },
        
        // 取消状态编辑
        cancelEditStatus(game: Game): void {
          if ((game as any).editingStatus) {
            (game as any).status = (game as any).originalStatus; // Revert to original value
            (game as any).editingStatus = null;
            this.editingStatus = null;
          }
        },
        
        // 处理状态下拉框可见性变化
        handleStatusSelectVisibleChange(visible: boolean, game: Game): void {
          if (!visible && (game as any).editingStatus) {
            // When the select dropdown closes, if still in editing mode, save or cancel
            // Add a small delay to allow click events on options to register
            setTimeout(() => {
              if ((game as any).editingStatus) { // Check again in case it was saved by @change
                this.saveEditStatus(game);
              }
            }, 100);
          }
        },

        startEditCategory(game: Game): void {
          if (this.loading) return;
          (game as any).editingCategory = true;
          (game as any).originalCategory = this.normalizeCategoryId(game.category as string | undefined);
          (game as any).originalCategoryName = game.categoryName || '';
        },

        async saveEditCategory(game: Game): Promise<void> {
          if (this.loading || !(game as any).editingCategory) return;

          const next = this.normalizeCategoryId(game.category as string | undefined);
          const orig = this.normalizeCategoryId((game as any).originalCategory);
          if (next === orig) {
            this.cancelEditCategory(game);
            return;
          }

          this.loading = true;
          try {
            await GameApi.updateGame(game.id, { category: next || undefined } as Partial<Game>);
            const opt = this.category_list.find((c) => c.id === next);
            game.categoryName = opt ? opt.name : (next ? this.getCategoryName(next) : '');
            game.category = next || undefined;
            ElMessage.success('分类更新成功');
          } catch (error) {
            console.error('更新分类失败:', error);
            ElMessage.error('更新分类失败，已恢复原值');
            game.category = (game as any).originalCategory || undefined;
            game.categoryName = (game as any).originalCategoryName;
          } finally {
            this.loading = false;
            (game as any).editingCategory = false;
          }
        },

        cancelEditCategory(game: Game): void {
          if ((game as any).editingCategory) {
            game.category = (game as any).originalCategory || undefined;
            game.categoryName = (game as any).originalCategoryName;
            (game as any).editingCategory = false;
          }
        },

        handleCategorySelectVisibleChange(visible: boolean, game: Game): void {
          if (!visible && (game as any).editingCategory) {
            setTimeout(() => {
              if ((game as any).editingCategory) {
                this.saveEditCategory(game);
              }
            }, 100);
          }
        },
        
        // 显示封面图对话框
        showCoverDialog(cover: string): void {
          // 使用 processImageUrl 处理图片 URL
          this.coverImageUrl = processImageUrl(cover, this.$CDN_URL);
          this.coverDialogVisible = true;
        },
        getGamePreviewUrl(game: Game): string {
          return (game.gameUrl || game.url || '').trim();
        },
        openGamePreview(game: Game): void {
          if (!this.getGamePreviewUrl(game)) {
            ElMessage.warning('该游戏未配置游戏 URL');
            return;
          }
          this.gamePreviewRow = game;
          this.gamePreviewMode = 'pc';
          this.gamePreviewDialogVisible = true;
        },
        findAdjacentPreviewGame(direction: -1 | 1): Game | null {
          if (!this.gamePreviewRow) return null;
          const currentIndex = this.data.findIndex((game) => game.id === this.gamePreviewRow?.id);
          if (currentIndex < 0) return null;
          for (
            let index = currentIndex + direction;
            index >= 0 && index < this.data.length;
            index += direction
          ) {
            if (this.getGamePreviewUrl(this.data[index])) {
              return this.data[index];
            }
          }
          return null;
        },
        hasAdjacentPreviewGame(direction: -1 | 1): boolean {
          return Boolean(this.findAdjacentPreviewGame(direction));
        },
        switchPreviewGame(direction: -1 | 1): void {
          const nextGame = this.findAdjacentPreviewGame(direction);
          if (nextGame) {
            this.gamePreviewRow = nextGame;
          }
        },
        async updatePreviewStatus(status: string): Promise<void> {
          if (!this.gamePreviewRow || this.gamePreviewUpdating) return;
          const game = this.gamePreviewRow;
          this.gamePreviewUpdating = true;
          try {
            await GameApi.updateGame(game.id, { status });
            game.status = status;
            ElMessage.success('上线状态更新成功');
          } catch (error) {
            console.error('更新上线状态失败:', error);
            ElMessage.error('上线状态更新失败');
          } finally {
            this.gamePreviewUpdating = false;
          }
        },
        async updatePreviewCategory(category: string): Promise<void> {
          if (!this.gamePreviewRow || this.gamePreviewUpdating) return;
          const game = this.gamePreviewRow;
          this.gamePreviewUpdating = true;
          try {
            await GameApi.updateGame(game.id, { category });
            game.category = category || undefined;
            const selectedCategory = this.category_list.find((item) => item.id === category);
            game.categoryName = selectedCategory?.name || '';
            ElMessage.success('分类更新成功');
          } catch (error) {
            console.error('更新分类失败:', error);
            ElMessage.error('分类更新失败');
          } finally {
            this.gamePreviewUpdating = false;
          }
        },
        closeGamePreview(): void {
          this.gamePreviewRow = null;
          this.gamePreviewMode = 'pc';
        },
        // 批量上传相关方法
        openBulkDialog(): void {
          this.bulkDialogVisible = true;
          this.bulkJsonText = '';
        },
        resetBulkDialog(): void {
          this.bulkDialogVisible = false;
          this.bulkJsonText = '';
          this.bulkFileList = [];
        },
        handleFileChange(file: any, fileList: any[]): void {
          // 更新文件列表
          this.bulkFileList = fileList;
          
          // 如果是单个 JSON 文件，读取内容到文本框（兼容旧功能）
          if (fileList.length === 1 && file.raw && file.raw.name.toLowerCase().endsWith('.json')) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const text = e.target?.result as string;
                this.bulkJsonText = text;
              } catch (error) {
                ElMessage.error('读取文件失败');
              }
            };
            reader.readAsText(file.raw);
          }
        },
        handleFileRemove(file: any, fileList: any[]): void {
          this.bulkFileList = fileList;
          // 如果删除的是当前显示在文本框中的文件，清空文本框
          if (fileList.length === 0) {
            this.bulkJsonText = '';
          }
        },
        async submitBulkUpload(): Promise<void> {
          // 优先使用文件上传
          if (this.bulkFileList && this.bulkFileList.length > 0) {
            this.bulkLoading = true;
            try {
              const formData = new FormData();
              // 添加所有文件到 FormData
              this.bulkFileList.forEach((fileItem: any) => {
                if (fileItem.raw) {
                  formData.append('files', fileItem.raw);
                }
              });
              
              const result = await GameApi.bulkCreateGamesWithFiles(formData);
              this.bulkResult = result;
              this.bulkDialogVisible = false;
              this.bulkResultDialogVisible = true;
              this.activeResultTab = result.failedCount > 0 ? 'failed' : 'success';
              
              if (result.successCount > 0) {
                ElMessage.success(`成功上传 ${result.successCount} 个游戏`);
              }
              if (result.failedCount > 0) {
                ElMessage.warning(`${result.failedCount} 个游戏上传失败，请查看详情`);
              }
            } catch (error) {
              ElMessage.error(`上传失败：${error instanceof Error ? error.message : '未知错误'}`);
            } finally {
              this.bulkLoading = false;
            }
            return;
          }
          
          // 如果没有文件，尝试使用文本框中的 JSON 数据（兼容旧功能）
          if (!this.bulkJsonText || this.bulkJsonText.trim() === '') {
            ElMessage.warning('请上传文件或输入 JSON 数据');
            return;
          }
          
          try {
            const jsonData = JSON.parse(this.bulkJsonText);
            let gamesArray: any[] = [];
            
            // 支持两种格式：数组或 {games: [...]}
            if (Array.isArray(jsonData)) {
              gamesArray = jsonData;
            } else if (jsonData && typeof jsonData === 'object' && Array.isArray(jsonData.games)) {
              gamesArray = jsonData.games;
            } else {
              ElMessage.error('JSON 格式错误：必须是数组或包含 games 数组的对象');
              return;
            }
            
            if (gamesArray.length === 0) {
              ElMessage.warning('游戏列表为空');
              return;
            }
            
            this.bulkLoading = true;
            const result = await GameApi.bulkCreateGames(gamesArray);
            this.bulkResult = result;
            this.bulkDialogVisible = false;
            this.bulkResultDialogVisible = true;
            this.activeResultTab = result.failedCount > 0 ? 'failed' : 'success';
            
            if (result.successCount > 0) {
              ElMessage.success(`成功上传 ${result.successCount} 个游戏`);
            }
            if (result.failedCount > 0) {
              ElMessage.warning(`${result.failedCount} 个游戏上传失败，请查看详情`);
            }
          } catch (error) {
            ElMessage.error(`JSON 解析失败：${error instanceof Error ? error.message : '未知错误'}`);
          } finally {
            this.bulkLoading = false;
          }
        },
        // 上传相关游戏相关方法
        openRelateBulkDialog(): void {
          this.relateBulkDialogVisible = true;
          this.relateBulkJsonText = '';
        },
        resetRelateBulkDialog(): void {
          this.relateBulkDialogVisible = false;
          this.relateBulkJsonText = '';
        },
        handleRelateFileChange(file: any): void {
          const reader = new FileReader();
          reader.onload = (e) => {
            try {
              const text = e.target?.result as string;
              this.relateBulkJsonText = text;
            } catch (error) {
              ElMessage.error('读取文件失败');
            }
          };
          reader.readAsText(file.raw);
        },
        async submitRelateBulkUpload(): Promise<void> {
          if (!this.relateBulkJsonText || this.relateBulkJsonText.trim() === '') {
            ElMessage.warning('请输入或上传 JSON 数据');
            return;
          }
          
          try {
            const jsonData = JSON.parse(this.relateBulkJsonText);
            
            // 验证数据格式：应该是对象，键为 gameId，值为相关游戏数组
            if (!jsonData || typeof jsonData !== 'object' || Array.isArray(jsonData)) {
              ElMessage.error('JSON 格式错误：必须是对象格式，键为 gameId，值为相关游戏数组');
              return;
            }
            
            if (Object.keys(jsonData).length === 0) {
              ElMessage.warning('数据为空');
              return;
            }
            
            this.relateBulkLoading = true;
            const result = await GameApi.bulkUploadRelateGames(jsonData);
            this.relateBulkResult = result;
            this.relateBulkDialogVisible = false;
            this.relateBulkResultDialogVisible = true;
            this.activeRelateResultTab = result.failedCount > 0 ? 'failed' : 'success';
            
            if (result.successCount > 0) {
              ElMessage.success(`成功上传 ${result.successCount} 个游戏的相关关系`);
            }
            if (result.failedCount > 0) {
              ElMessage.warning(`${result.failedCount} 个游戏上传失败，请查看详情`);
            }
          } catch (error) {
            ElMessage.error(`JSON 解析失败：${error instanceof Error ? error.message : '未知错误'}`);
          } finally {
            this.relateBulkLoading = false;
          }
        },
        // 热门游戏上传相关方法
        openHotBulkDialog(): void {
          this.hotBulkDialogVisible = true;
          this.hotBulkJsonText = '';
        },
        resetHotBulkDialog(): void {
          this.hotBulkDialogVisible = false;
          this.hotBulkJsonText = '';
        },
        handleHotFileChange(file: any): void {
          const reader = new FileReader();
          reader.onload = (e) => {
            try {
              const text = e.target?.result as string;
              this.hotBulkJsonText = text;
            } catch (error) {
              ElMessage.error('读取文件失败');
            }
          };
          reader.readAsText(file.raw);
        },
        async submitHotBulkUpload(): Promise<void> {
          if (!this.hotBulkJsonText || this.hotBulkJsonText.trim() === '') {
            ElMessage.warning('请输入或上传 JSON 数据');
            return;
          }
          
          try {
            const jsonData = JSON.parse(this.hotBulkJsonText);
            
            // 验证数据格式：应该是数组
            if (!Array.isArray(jsonData)) {
              ElMessage.error('JSON 格式错误：必须是数组格式');
              return;
            }
            
            if (jsonData.length === 0) {
              ElMessage.warning('数据为空');
              return;
            }
            
            this.hotBulkLoading = true;
            const result = await GameApi.bulkUploadHotGames(jsonData);
            this.hotBulkResult = result;
            this.hotBulkDialogVisible = false;
            this.hotBulkResultDialogVisible = true;
            this.activeHotResultTab = result.failedCount > 0 ? 'failed' : 'success';
            
            if (result.successCount > 0) {
              ElMessage.success(`成功上传 ${result.successCount} 个热门游戏`);
            }
            if (result.failedCount > 0) {
              ElMessage.warning(`${result.failedCount} 个游戏上传失败，请查看详情`);
            }
          } catch (error) {
            ElMessage.error(`JSON 解析失败：${error instanceof Error ? error.message : '未知错误'}`);
          } finally {
            this.hotBulkLoading = false;
          }
        },
        // 最受欢迎游戏上传相关方法
        openTopPerformerBulkDialog(): void {
          this.topPerformerBulkDialogVisible = true;
          this.topPerformerBulkJsonText = '';
        },
        resetTopPerformerBulkDialog(): void {
          this.topPerformerBulkDialogVisible = false;
          this.topPerformerBulkJsonText = '';
        },
        handleTopPerformerFileChange(file: any): void {
          const reader = new FileReader();
          reader.onload = (e) => {
            try {
              const text = e.target?.result as string;
              this.topPerformerBulkJsonText = text;
            } catch (error) {
              ElMessage.error('读取文件失败');
            }
          };
          reader.readAsText(file.raw);
        },
        async submitTopPerformerBulkUpload(): Promise<void> {
          if (!this.topPerformerBulkJsonText || this.topPerformerBulkJsonText.trim() === '') {
            ElMessage.warning('请输入或上传 JSON 数据');
            return;
          }
          
          try {
            const jsonData = JSON.parse(this.topPerformerBulkJsonText);
            
            // 验证数据格式：应该是数组
            if (!Array.isArray(jsonData)) {
              ElMessage.error('JSON 格式错误：必须是数组格式');
              return;
            }
            
            if (jsonData.length === 0) {
              ElMessage.warning('数据为空');
              return;
            }
            
            this.topPerformerBulkLoading = true;
            const result = await GameApi.bulkUploadTopPerformerGames(jsonData);
            this.topPerformerBulkResult = result;
            this.topPerformerBulkDialogVisible = false;
            this.topPerformerBulkResultDialogVisible = true;
            this.activeTopPerformerResultTab = result.failedCount > 0 ? 'failed' : 'success';
            
            if (result.successCount > 0) {
              ElMessage.success(`成功上传 ${result.successCount} 个最受欢迎游戏`);
            }
            if (result.failedCount > 0) {
              ElMessage.warning(`${result.failedCount} 个游戏上传失败，请查看详情`);
            }
          } catch (error) {
            ElMessage.error(`JSON 解析失败：${error instanceof Error ? error.message : '未知错误'}`);
          } finally {
            this.topPerformerBulkLoading = false;
          }
        },
    },
    async mounted(): Promise<void> {
        // 预加载 sortablejs
        await loadSortable();
        this.init();
    },
    beforeUnmount(): void {
        // 清理所有防抖定时器
        if ((this as any).reloadTimer) {
            clearTimeout((this as any).reloadTimer);
        }
        Object.keys(this).forEach(key => {
            if (key.startsWith('switchTimer_')) {
                clearTimeout((this as any)[key]);
            }
        });
        // 销毁拖拽实例
        if (this.sortableInstance) {
            this.sortableInstance.destroy();
            this.sortableInstance = null;
        }
    }
})
</script>

<style scoped>
.table-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 128px); /* 减去header和footer的高度 */
  overflow: hidden;
  background-color: #fff;
}

.fixed-header {
  background-color: #fff;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  z-index: 10;
  flex-shrink: 0;
}

.table-wrapper {
  flex: 1;
  overflow-y: auto;
  margin: 10px 0;
  position: relative;
}

/* 设置表格高度，使其适应容器 */
.table-wrapper .el-table {
  width: 100%;
}

/* 固定表头 */
.table-wrapper :deep(.el-table__header-wrapper) {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

/* 固定操作列样式优化 */
.table-wrapper :deep(.el-table__fixed-right) {
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
}

.table-wrapper :deep(.el-table__fixed-right-patch) {
  background-color: #fff;
}

.fixed-pagination {
  background-color: #fff;
  padding: 10px 0;
  border-top: 1px solid #ebeef5;
  z-index: 10;
  flex-shrink: 0;
}

/* 拖拽手柄样式 */
.drag-handle {
  cursor: move;
  user-select: none;
}

.drag-handle:hover {
  color: #409eff !important;
}

/* 拖拽时的行样式 */
.table-wrapper :deep(.sortable-ghost) {
  opacity: 0.4;
  background-color: #f0f9ff;
}

.markdown-preview {
  min-height: 320px;
  max-height: 60vh;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 12px;
  background-color: #fff;
  line-height: 1.7;
}

.game-preview-content {
  display: flex;
  flex-direction: column;
  height: calc(96vh - 105px);
  min-height: 0;
}

.game-preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 16px;
}

.game-preview-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.game-preview-label {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
}

.game-preview-url {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.game-preview-url .el-input {
  flex: 1;
}

.game-preview-size {
  color: #909399;
  font-size: 13px;
}

.game-preview-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 16px;
  background: #303133;
  border-radius: 8px;
}

.game-preview-stage iframe {
  display: block;
  border: 0;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.35);
}

.game-preview-stage.is-pc iframe {
  width: 100%;
  height: 100%;
}

.game-preview-stage.is-mobile iframe {
  width: 390px;
  height: min(700px, 100%);
  max-width: 100%;
  max-height: 100%;
  flex: 0 0 auto;
  border-radius: 12px;
}
</style>